import { FeatureToggleClientService } from 'feature-toggle-client';
const ClickTrackerEnabled = 'click-tracker-enabled';
const ClickTrackerNews = 'click-tracker-news';
const SmartIcebreakerEnabled = 'smart-icebreaker-enabled';
export class ClickTrackerFeatures {
    static isClickTrackerEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ClickTrackerEnabled);
    }
    static isClickTrackerNews() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ClickTrackerNews);
    }
    static IsSmartIcebreakerEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(SmartIcebreakerEnabled);
    }
}
